import Rut from 'rutjs';

/**
 * Validates a Chilean RUT string via rutjs using const bindings (S3504).
 */
export function isValidChileanRut(rutString) {
  const rutObject = new Rut(rutString);
  return rutObject.isValid;
}
